import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { Option } from '../../../../../core/models/option.model';
import { PriceMediaService } from '../../core/price-media.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TOASTER_TYPE } from '../../../../../components/toaster/toaster.model';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import { AccountSelectionService } from '../../../user/account/components/login-form/account-selection/account-selection.service';

enum FORMAT_TYPES {
  STANDARD = 'STANDARD',
  PPIF = 'PPIF',
}

enum EXPORT_TYPES {
  XLSX = 'XLSX',
  TXT = 'TXT',
  CSV = 'CSV',
}

@Component({
  selector: 'price-media-request',
  templateUrl: './price-media-request.component.html',
  styleUrl: './price-media-request.component.scss',
  standalone: false,
})
export class PriceMediaRequestComponent implements OnInit {
  displayAccount: any;
  isLoading$ = new BehaviorSubject<boolean>(false);
  constructor(
    protected fb: FormBuilder,
    private priceMediaService: PriceMediaService,
    public toasterService: ToasterService,
    protected accountSelectionService: AccountSelectionService,
  ) {}

  ngOnInit(): void {
    this.accountSelectionService.get().subscribe(data => (this.displayAccount = data.displayAccount));
  }

  formatTypeOptions$ = new BehaviorSubject<Option[]>([
    { code: FORMAT_TYPES.STANDARD, label: 'Standard' },
    { code: FORMAT_TYPES.PPIF, label: 'PPIF' },
  ]);

  exportTypeOptions$ = new BehaviorSubject<Option[]>([
    { code: EXPORT_TYPES.XLSX, label: 'Excel XLSX' },
    { code: EXPORT_TYPES.TXT, label: 'TXT' },
    { code: EXPORT_TYPES.CSV, label: 'CSV' },
  ]);

  form: FormGroup = this.fb.group({
    specialPricing: [true, [Validators.required]],
    priceEffectiveDate: [null, [Validators.required]],
    formatType: [null, [Validators.required]],
    exportTypes: [null, [Validators.required]],
  });

  loadPriceMedia() {
    this.form.markAllAsTouched();

    if (this.form.invalid) return;

    this.isLoading$.next(true);

    const payload = this.handlerPayload();

    this.priceMediaService
      .loadPriceMedia(payload)
      .pipe(take(1))
      .subscribe(response => {
        if (response.hasError) {
          this.toasterService.init({
            type: TOASTER_TYPE.DANGER,
            content: response.message || '',
          });
        } else {
          if (response.priceMedia && response.priceMedia.mediaRequestID) {
            this.toasterService.init({
              type: TOASTER_TYPE.SUCCESS,
              timeToClose: 10000,
              content: `Request Successfully! Your media request id is ${response.priceMedia.mediaRequestID}` || '',
            });
          } else {
            this.toasterService.init({
              type: TOASTER_TYPE.INFO,
              content: `Media Request ID not generated`,
            });
          }
        }

        this.form.reset();
        this.isLoading$.next(false);
      });
  }

  handlerPayload() {
    return {
      requestType: this.form.get('specialPricing')?.value ? 'DIRECT ACCOUNT' : '',
      priceEffectiveDate: this.form.get('priceEffectiveDate')?.value,
      formatType: this.form.get('formatType')?.value,
      brands: 'BROW,MORS,KOPF,SLMS,HUBC,ROLW,AERO,SP,GRVG,MCGI',
      exportTypes: this.form.get('exportTypes')?.value,
    };
  }
}
